import { Injectable } from '@angular/core';
import { AccountInfo } from '@azure/msal-browser';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private userSubject = new BehaviorSubject<AccountInfo>(null);
  constructor() { }

  getUser(): Observable<AccountInfo> {
    return this.userSubject.asObservable();
  }

  setUser(result: AccountInfo){
    this.userSubject.next(result);
  }
}
